"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaIndex = void 0;
const utils_1 = require("./utils");
class SchemaIndex {
    constructor(dependencyIndex) {
        this.dependencyIndex = dependencyIndex;
        this.schemas = {};
    }
    addSchemaToIndex(schema, ownRefPath) {
        (0, utils_1.traverse)(schema, (val) => {
            if ((0, utils_1.isRef)(val)) {
                this.dependencyIndex.addRefToIndex(val, ownRefPath);
                return true;
            }
        }, utils_1.SMALL_FACTOR);
    }
    removeSchemaFromIndex(schema, ownRefPath) {
        if (schema !== utils_1.EMPTY_SCHEMA) {
            (0, utils_1.traverse)(schema, (val) => this.dependencyIndex.removeRefFromIndex(val, ownRefPath), utils_1.SMALL_FACTOR);
        }
    }
}
exports.SchemaIndex = SchemaIndex;
//# sourceMappingURL=SchemaIndex.js.map